import FormRow from 'modules/core/components/FormRow'
import Select from 'modules/core/components/Select'
import i18n from 'modules/core/lib/i18n'

import ActivityEndDatePicker from './Daypicker'
import EmployeeTerminationDatePicker from './EmployeeTerminationDate'
import ReassignManagerSelect from './ReassignManagerSelect'
import Warning from './Warning'

interface EmployeeTerminationConstraints {
  minDate?: Date
  maxDate?: Date
  readonly: boolean
}

interface Props {
  employeeId: number
  activityEndDate: string
  setActivityEndDate: (value: string) => void
  employeeTerminationDate: string
  setEmployeeTerminationDate: (value: string) => void
  managerId: number | null
  setManagerId: (value: number | null) => void
  employeeTerminationConstraints: EmployeeTerminationConstraints
  lastEffectiveOnDate: Date
}

const FirstStep = ({
  employeeId,
  activityEndDate,
  setActivityEndDate,
  employeeTerminationDate,
  setEmployeeTerminationDate,
  managerId,
  setManagerId,
  employeeTerminationConstraints,
  lastEffectiveOnDate,
}: Props) => {
  const terminationReason = i18n.t(
    'contract_versions.header.pause_resume.pause_modal.termination_reason_default'
  )

  const terminationReasonOptions = [
    {
      label: terminationReason,
      value: terminationReason,
    },
  ]

  return (
    <>
      <ActivityEndDatePicker
        value={activityEndDate}
        onChange={setActivityEndDate}
        lastEffectiveOnDate={lastEffectiveOnDate}
      />

      <EmployeeTerminationDatePicker
        value={employeeTerminationDate}
        onChange={setEmployeeTerminationDate}
        minDate={employeeTerminationConstraints.minDate}
        maxDate={employeeTerminationConstraints.maxDate}
        readonly={employeeTerminationConstraints.readonly}
      />

      <FormRow>
        <Select
          label={i18n.t(
            'contract_versions.header.pause_resume.pause_modal.termination_reason_label'
          )}
          options={terminationReasonOptions}
          value={terminationReason}
          onChange={() => {}} // Disabled field
          readonly
        />
      </FormRow>

      <FormRow>
        <ReassignManagerSelect employeeId={employeeId} value={managerId} onChange={setManagerId} />
      </FormRow>

      <Warning />
    </>
  )
}

export default FirstStep
